export default __webpack_public_path__ + "static/media/tw.4e829e18.svg";